import React, { memo, useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import moment from "moment";
import { DATE_FORMAT_DEFAULT } from "../../utils/constants";
import { EmptyText } from "../../components/common/CellText";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import EmptyData from "../../components/image/EmptyData";
import UnreadText from "../../components/common/UnreadText";
import ContentModal from "../../components/dialog/ContentModal";
import SkeletonTable from "./../../components/Skeleton/SkeletonTable";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spin } from "antd";
import { Button, useTheme } from "@mui/material";
import { HiOutlineDocumentText } from "react-icons/hi2";
import InternalDocumentOutgoingCreate from "./InternalDocumentOutgoingCreate";
import AdvancedFilter from "./AdvancedFilter";
import { AiOutlineSearch } from "react-icons/ai";
const checkUnread = (record) => record.status_doc_outgoing !== "READ";

function createData(
  outgoing_date,
  document_number,
  title,
  authority_issued,
  signer,
  code
) {
  return {
    outgoing_date,
    document_number,
    title,
    authority_issued,
    signer,
    code,
  };
}

const InternalDocumentOutgoing = (props) => {
  const {
    internalDocumentStore,
    createMessage,
    openAdvancedFilter,
    setOpenAdvancedFilter,
  } = props;
  const { internalDocumentOutgoingList, getInternalDocumentOutgoingList } =
    internalDocumentStore;
  const location = useLocation();
  const navigate = useNavigate();
  const queryStringParse = queryString.parse(location.search, {
    arrayFormat: "index",
  });
  const [isRefreshPage, setIsRefreshPage] = useState(true);
  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    title: null,
    signer: null,
    value: null,
  });
  const [loading, setLoading] = useState(true);
  const [openContent, setOpenContent] = useState(false);
  const [workSelect] = useState({});
  const CO_QUAN_BAN_HANH_WIDTH = 200;
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const param = {
      page: queryStringParse.page || filter.page,
      size: queryStringParse.size || filter.size,
      title: queryStringParse.title || filter.title,
      signer: queryStringParse.signer || filter.signer,
      value: queryStringParse.value || filter.value,
    };
    setFilter(param);
    (async () => {
      setLoading(true);
      internalDocumentStore.clearInternalDocumentOutgoingList();
      internalDocumentStore.clearInternalDocumentOutgoingListFilter();
      await getInternalDocumentOutgoingList(param);
      setIsRefreshPage(false);
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isRefreshPage) return;
    const queryStringStringify = queryString.stringify(filter, {
      skipNull: true,
    });
    navigate({
      pathname: "/internal-document/outgoing-document",
      search: queryStringStringify,
    });
    (async () => {
      try {
        setLoading(true);
        internalDocumentStore.clearInternalDocumentOutgoingList();
        internalDocumentStore.clearInternalDocumentOutgoingListFilter();
        await getInternalDocumentOutgoingList(filter);
        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => {
    setRows(
      internalDocumentOutgoingList.map((record) =>
        createData(
          <UnreadText
            width={96}
            text={moment(record.outgoing_date).format(DATE_FORMAT_DEFAULT)}
            isUnread={checkUnread(record)}
          />,
          <UnreadText
            text={
              <div className="flex gap-2 w-[100%] items-center">
                <HiOutlineDocumentText size={20} color={theme.color.primary} />
                <div
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "100%",
                    color: theme.color.primary,
                  }}
                >
                  {record.document_number}
                </div>
              </div>
            }
            isUnread={checkUnread(record)}
            width={"100%"}
          />,

          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
              lineHeight: "25px",
              WebkitLineClamp: "2",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              maxHeight: "50px",
              padding: "4px",
            }}
          >
            {record.title}
          </div>,

          <UnreadText
            text={record.authority_issued}
            isUnread={checkUnread(record)}
            width={CO_QUAN_BAN_HANH_WIDTH}
          />,
          record.signer ? (
            <UnreadText
              text={record.signer}
              isUnread={checkUnread(record)}
              width={"100%"}
            />
          ) : (
            <EmptyText>Không có người ký </EmptyText>
          ),
          record.code
        )
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalDocumentOutgoingList]);

  const theme = useTheme();
  const [hasMore, setHasMore] = useState(false);
  const fetchMoreData = async () => {
    if (
      internalDocumentOutgoingList.length >=
      internalDocumentStore.internalDocumentOutgoingListTotalCount
    ) {
      setHasMore(false);
      return;
    }
    internalDocumentStore.setQueryParamsOutDoc({
      page: internalDocumentStore.defaultQueryParamsOutDoc.page + 1,
      size: 10,
    });
    try {
      setHasMore(true);

      await internalDocumentStore.getInternalDocumentOutgoingList({
        ...filter,
        page: internalDocumentStore.defaultQueryParamsOutDoc.page,
        size: 10,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const [check, setCheck] = useState(false);
  const [checkV2, setCheckV2] = useState(false);

  useEffect(() => {
    internalDocumentStore.clear();
  }, [check, checkV2]);

  useEffect(() => {
    if (
      internalDocumentOutgoingList.length <=
      internalDocumentStore.internalDocumentOutgoingListTotalCount
    ) {
      setHasMore(true);
      return;
    }
  }, [check, checkV2]);

  const [value, setValue] = useState("");
  const handleQuickSearch = async (event) => {
    internalDocumentStore.clearInternalDocumentOutgoingList();
    internalDocumentStore.clearInternalDocumentOutgoingListFilter();
    event.preventDefault();
    try {
      setLoading(true);
      await internalDocumentStore.getInternalDocumentOutgoingList({
        ...filter,
        title: value,
      });
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [openCreateOutgoingDoc, setOpenCreateOutgoingDoc] = useState(false);

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        style={{ margin: "10px", textTransform: "none" }}
        onClick={() => {
          setOpenCreateOutgoingDoc(true);
        }}
      >
        Tạo mới văn bản đi
      </Button>
      <form onSubmit={(e) => handleQuickSearch(e)}>
        <div
          className="mt-2 px-5 py-3 rounded-xl w-full  focus-visible:outline-none"
          style={{
            display: "flex",
            alignItems: "center",
            background: theme.background.light,
          }}
        >
          <AiOutlineSearch color="#65696e" fontSize={25} />
          <input
            type="text"
            placeholder="Tìm kiếm"
            className="py-1 rounded-xl w-full  focus-visible:outline-none"
            style={{ background: theme.background.light }}
            value={filter.value}
            onChange={(e) => {
              // internalDocumentStore.clearInternalDocumentOutgoingList();
              // internalDocumentStore.clearInternalDocumentOutgoingListFilter();
              // setFilter({
              //   ...filter,
              //   page: 0,
              //   size: 10,
              //   title: e.target.value.trim(),
              //   value: e.target.value,
              // });
              setValue(e.target.value.trim());
            }}
            // onBlur={(e) => handleQuickSearch(e)}
            // onKeyDown={(e) => {
            //   if (e.key === "Enter") {
            //     handleQuickSearch(e);
            //   }
            // }}
          />
        </div>
      </form>
      {loading ? (
        <SkeletonTable />
      ) : internalDocumentOutgoingList?.length > 0 ? (
        <>
          <section className="mt-1 pb-[30px] overflow-x-auto hideScrollbar">
            <InfiniteScroll
              dataLength={internalDocumentOutgoingList.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  {internalDocumentOutgoingList?.length > 10 ? (
                    <Spin tip="Đang tải..." />
                  ) : (
                    ""
                  )}
                </div>
              }
              scrollableTarget={"divScroll"}
            >
              <div className="inline-block w-[100%] overflow-visible hideScrollbar  ">
                {rows.map((row) => (
                  <div
                    onClick={() => {
                      navigate(
                        `/internal-document/outgoing-document/view/${row.code}`
                      );
                    }}
                    key={row.code}
                    style={{
                      backgroundColor: theme.background.light,
                      padding: "5px",
                      margin: " 10px 0px",
                      borderRadius: "10px",
                      boxShadow: theme.boxShadow.boxShadow1,
                    }}
                  >
                    <div className="flex justify-between items-center">
                      <div
                        className="pt-1"
                        style={{ width: "calc(100% - 96px)" }}
                      >
                        {row.document_number}
                      </div>
                      {/* <div
                        className="flex items-center"
                        style={{
                          width: 96,
                          fontSize: 13,
                          color: theme.color.gray,
                        }}>
                        <div style={{ paddingRight: 3 }}>
                          <AiOutlineFieldTime
                            size={15}
                            color={theme.color.gray}
                          />
                        </div>
                        {row.outgoing_date}
                      </div> */}
                    </div>

                    <div className="w-[100%] mb-2">{row.title}</div>
                    <div className="flex justify-end">
                      <div
                        style={{
                          padding: "2px 8px 2px 6px",
                          border: "1px solid #2c65ac",
                          borderRadius: "5px",
                          background: theme.background.rgba1,
                          color: theme.color.primary,
                          display: "inline-block",
                        }}
                      >
                        {row.signer}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </InfiniteScroll>
          </section>
        </>
      ) : (
        <EmptyData />
      )}
      <ContentModal
        open={openContent}
        handleClose={() => {
          setOpenContent(false);
        }}
        // content={workSelect?.title}
        headerTitle="Văn bản đi"
      />
      <InternalDocumentOutgoingCreate
        createMessage={createMessage}
        setFilter={setFilter}
        open={openCreateOutgoingDoc}
        handleClose={() => {
          setOpenCreateOutgoingDoc(false);
        }}
        check={check}
        setCheck={setCheck}
      />
      <AdvancedFilter
        openAdvancedFilter={openAdvancedFilter}
        handleOpenAdvancedFilter={() => {
          setOpenAdvancedFilter(true);
        }}
        handleCloseAdvancedFilter={() => {
          setOpenAdvancedFilter(false);
        }}
        filter={filter}
        setFilter={setFilter}
        checkV2={checkV2}
        setCheckV2={setCheckV2}
      />
    </>
  );
};

export default memo(
  inject("internalDocumentStore")(observer(InternalDocumentOutgoing))
);
